import React from 'react';
import SuperTooltipRenderer from './SuperTooltipRenderer';
import { useSuperTooltipVM } from './super-tooltip.viewModel';
import { SuperTooltipTemplateId } from './generated';
import { icon, tooltipElement } from './SuperTooltip.css';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

export interface SuperTooltipProps {
  templateId: SuperTooltipTemplateId;
  slideIndex?: number;
  hideNavigation?: boolean;
  wrapperClassName?: string;
  showDivider?: boolean;
  title?: string;
}

const SuperTooltip: React.FC<SuperTooltipProps> = ({
  templateId,
  slideIndex,
  hideNavigation,
  wrapperClassName,
  showDivider,
  title,
}) => {
  const vm = useSuperTooltipVM({
    templateId,
    slideIndex,
    hideNavigation: hideNavigation ?? false,
    wrapperClassName,
    showDivider,
  });

  return (
    <>
      <div onClick={vm.onOpen} className={tooltipElement}>
        <FontAwesomeIcon icon={faStar} className={icon} />
        {title && (
          <Typography variant="body" size="small">
            {title}
          </Typography>
        )}
      </div>

      <SuperTooltipRenderer {...vm} />
    </>
  );
};

export default SuperTooltip;
